import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { User, Workspace } from '@/hooks/api/models';

/**
 * 0151. ワークスペースユーザ詳細
 * [GET] /workspaces/:identifier/users/:id
 */
type Props = {
  identifier: string;
  id: number;
};
const workspaceUser = (props: Props): Promise<User> => {
  return axios.get(`/api/workspaces/${props.identifier}/users/${props.id}`);
};

export const useWorkspaceUser = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'users', props.id],
    queryFn: () => workspaceUser(props),
  });
};
